// 👇 1. 把 createWebHashHistory 改为 createWebHistory
import { createRouter, createWebHistory } from 'vue-router' 
import HomeView from '../views/HomeView.vue'
import CretaceousHomeView from '../views/CretaceousHomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/cretaceous',
    name: 'cretaceous',
    component: CretaceousHomeView 
  },
  {
    path: '/data',
    name: 'data',
    component: () => import('../views/DatatView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  }
]

const router = createRouter({
  // 👇 2. 这里改为 createWebHistory，正式开启干净的无 # 模式
  history: createWebHistory(process.env.BASE_URL), 
  routes
})

export default router